import { styled } from "@mui/material/styles";

const StyledContainerHeader = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 0, 3, 1),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "baseline",
}));

export default StyledContainerHeader;
